import BigNumber from 'bignumber.js';
import { bigNumberSerializer } from './BigNumberSerializer';
import { serializerRegistrations } from './serializerRegistrations';
let isRegistered = false;
export function registerBigNumberSerializers() {
    if (isRegistered) {
        return;
    }
    serializerRegistrations.push({ type: BigNumber, serializer: bigNumberSerializer });
    isRegistered = true;
}
